import { loadScript } from 'nova-helpers';

class NovaWidgetInit {
  private static instance: NovaWidgetInit;
  loadedScript: Map<string, any>;

  constructor(data: any) {
    if (NovaWidgetInit.instance) {
      throw new Error('Error - use Singleton.getInstance()');
    }
    const { entryPoints } = data;
    this.loadedScript = new Map();
    const mountHandler = ({ detail }: any) => {
      const { name } = detail;
      const script = entryPoints.find(
        (entry: { name: any }) => entry.name === name
      );

      if (typeof script !== undefined && typeof script.url !== undefined) {
        // Load script only if not loaded earlier
        if (
          typeof this.loadedScript.get(name) === 'undefined' ||
          !this.loadedScript.get(name)
        ) {
          loadScript(script.url).then((result: any) => {
            if (typeof result !== 'undefined') {
              this.loadedScript.set(name, true);
            }
          });
        }
      }
    };

    document.addEventListener('NovaMount', mountHandler);
  }

  static initialize(data: any): NovaWidgetInit {
    NovaWidgetInit.instance =
      NovaWidgetInit.instance || new NovaWidgetInit(data);
    return NovaWidgetInit.instance;
  }
}

export default NovaWidgetInit;
